export const formTheme = {
  parts: ['container', 'requiredIndicator', 'helperText'],
  baseStyle: {
    requiredIndicator: {
      color: 'primaryColor',
    },
  },
};
